<template>
  <!-- <HelloWorld /> -->
  <div>
    <v-container>
      <Welcome />

      <v-layout row wrap v-if="token || currentUser">
        <v-flex xs12>
          <v-card>
            <v-card-title primary-title class="title">
              {{ $t('templates') }}
            </v-card-title>
            <TemplateList />
          </v-card>
        </v-flex>
        <v-flex xs12 pt-3>
          <v-card>
            <v-card-title primary-title class="title">
              {{ $t('evaluations') }}
            </v-card-title>
            <EvaluationList />
          </v-card>
        </v-flex>
      </v-layout>
      <div v-else>
        <UserSelect/>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Welcome from '../components/Welcome'
  import TemplateList from '../components/TemplateList'
  import EvaluationList from '../components/EvaluationList'
  import UserSelect from './UserSelect'

  export default {
    components: {
      Welcome,
      TemplateList,
      EvaluationList,
      UserSelect
    },
    computed: {
      token() { return localStorage.token },
      currentUser() { return this.$store.state.currentUser }
    },
  }
</script>
